'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React from 'react';
import {List} from '../../../components/lists/List';
import {isCordovaBuild} from '../../../config/constants';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {getMessagesFromProps, I18nComponent} from '../../../core-utilities/react-i18n';
import {getItemClass} from '../../../core-utilities/redux';
import {getIsOpeningFulfillment, getIsOpeningUpload} from '../../utils';
import {FileFulfillmentItem} from '../FileFulfillmentItem';
import {FileFulfillmentPendingItem} from '../FileFulfillmentPendingItem';


const browserNoFiles = require('../../../../img/no-files-browser.png');
const mobileNoFiles = require('../../../../img/no-files-mobile.png');

export function BaseFileFulfillmentListView(props) {
  const name = get(props.requirement, 'name', '');
  const showNoData = props.uploading ? props.uploading.length === 0 : true;
  return (
    <List
      className={classNames("FileFulfillmentList", props.className, {
        FileFulfillmentList__minimalView: props.minimalView,
      })}
      useScroll={props.useScroll}
      flipped={false}
      autoScroll={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}

      showNoData={showNoData}
      showNoDataIcon={showNoData}
      noDataTitle={props.isCordovaBuild ? props.mobilePlaceholderTitle : props.browserPlaceholderTitle}
      noDataLabel={props.isCordovaBuild ? props.mobilePlaceholderLabel : props.browserPlaceholderLabel}
      noDataIcon={props.isCordovaBuild
        ? mobileNoFiles
        : browserNoFiles
      }
      useNoDataImage={true}
      transitionGroupClass={"FileFulfillmentList__container"}
    >
      {props.list ? props.list.map(model => (
        <FileFulfillmentItem
          key={getId(model)}
          className={classNames(getItemClass(model))}
          init={props.init}
          userId={props.userId}
          name={name}
          model={model}
          isOpening={getIsOpeningFulfillment(props.openingFileId, model)}
          onClick={props.onClickItem}
          onContextMenu={props.onItemContextMenu}

          {...getMessagesFromProps(props, FileFulfillmentItem.messageProps)}
        />
      )) : null}
      {props.uploading ? props.uploading.map(model => (
        <FileFulfillmentPendingItem
          key={model.key}
          name={name}
          model={model}
          isOpening={getIsOpeningUpload(props.openingFileId, model)}
          onClick={props.onClickUpload}

          {...getMessagesFromProps(props, FileFulfillmentPendingItem.messageProps)}
        />
      )) : null}
    </List>
  );
}

BaseFileFulfillmentListView.propTypes = {
  className: T.string,
  userId: T.string.isRequired,
  requirement: T.object,
  isCordovaBuild: T.bool.isRequired,

  onClickItem: T.func.isRequired,
  onItemContextMenu: T.func.isRequired,
  onClickUpload: T.func.isRequired,

  browserPlaceholder: T.string,
  mobilePlaceholder: T.string,

  init: T.bool,
};

BaseFileFulfillmentListView.defaultProps = {
  // Move to Container if we end up needing one for anything else
  isCordovaBuild: isCordovaBuild(),
  init: true,
};

export const FileFulfillmentListView = I18nComponent(BaseFileFulfillmentListView, [
  {code: 'requirements.files.view.browser.placeholder.title', prop: 'browserPlaceholderTitle'},
  {code: 'requirements.files.view.mobile.placeholder.title', prop: 'mobilePlaceholderTitle'},
  {code: 'requirements.files.view.browser.placeholder.label', prop: 'browserPlaceholderLabel'},
  {code: 'requirements.files.view.mobile.placeholder.label', prop: 'mobilePlaceholderLabel'},
  ...FileFulfillmentItem.messages,
  ...FileFulfillmentPendingItem.messages,
]);



// WEBPACK FOOTER //
// ./src/js/requirements/components/FileFulfillmentList/FileFulfillmentListView.js